import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    hasLogin: false,
    userInfo: {}
  },
  mutations: {
    login(state, provider) {
      state.hasLogin = true
      state.userInfo = provider
      uni.setStorageSync('userInfo', provider)
    },
    logout(state) {
      state.hasLogin = false
      state.userInfo = {}
      uni.removeStorageSync('userInfo')
    }
  },
  actions: {

  },
  getters: {
    getUserInfo(state) {
      return state.userInfo
    }
  }
})

export default store
